import { render, staticRenderFns } from "./statisticalCalendar.vue?vue&type=template&id=74b65dfe&scoped=true&"
import script from "./statisticalCalendar.vue?vue&type=script&lang=js&"
export * from "./statisticalCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b65dfe",
  null
  
)

export default component.exports